// extracted by mini-css-extract-plugin
export default {"line_box":"Fz43jH_qItE17RzCO_bl"};